import React, { useState } from "react";
import { AppConfig } from "../../../../api/config/config";
import { FilePreview, GeneralImage, Modal } from "../../../../components";

const DoctorCertificateDetails: React.FC<{ certificate?: any }> = ({
  certificate,
}) => {
  const [isFileOpen, setIsFileOpen] = useState<boolean>(false);
  return (
    <>
      <div className="flex flex-col gap-4 xl:flex-row">
        <div className="bg-input-field h-fit w-full cursor-pointer overflow-hidden rounded-lg border xl:max-w-[25vw]">
          <GeneralImage
            src={certificate?.Image}
            alt={certificate?.Name}
            className="max-h-[27rem] w-full object-cover"
            width="100%"
            onClick={() => setIsFileOpen(true)}
          />
          <div className="flex flex-col gap-1 p-3">
            <div className="flex justify-between font-bold">
              <span>{certificate?.Name}</span>
              <span>{certificate?.Date}</span>
            </div>
            <p>{certificate?.Authority}</p>
          </div>
        </div>
        <p>{certificate?.Description}</p>
      </div>

      {isFileOpen && (
        <Modal
          header={certificate?.Name}
          width="max-w-4xl"
          isOpen={isFileOpen}
          onClose={() => setIsFileOpen(false)}
        >
          <FilePreview
            type={"IMAGE"}
            url={AppConfig.SERVER_URL + certificate?.Image}
          />
        </Modal>
      )}
    </>
  );
};

export default DoctorCertificateDetails;
